export default __webpack_public_path__ + "static/media/media_play.86b126d9.svg";